import { useActiveCallsHealthCheck } from './hooks/useActiveCallsHealthCheck.hook';

/**
 * Component that manages the active calls health check.
 * This should be mounted once at the app level.
 *
 * Periodically validates that calls shown in the just-in-time display
 * are still actually active on the backend, and automatically removes
 * any that have ended.
 */
export const ActiveCallsHealthCheckManager = () => {
  // Run health check every 60 seconds (1 minute)
  useActiveCallsHealthCheck({
    intervalMs: 60000,
    enabled: true,
  });

  // This component doesn't render anything
  return null;
};
